import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonTertiary,
} from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import { useProductContext } from '../Product';
import BYBModal from '../BYBmodal';

const Header = ({ showBannerLink }) => {
  const { product: { cardArt, productName } } = useProductContext();
  const [showBYBModal, setShowBYBModal] = useState(false);

  const toggleBYBModal = () => {
    setShowBYBModal(!showBYBModal);
  };

  return (
    <>
      <div className="container pad-1-tb">
        <div className="row stack-1-sm-down">
          <div className="col-md-9 col-xl-8 flex flex-align-items-center">
            <img className="dls-card-md" src={cardArt} alt="Card Art" />
            <h1 className="dls-white pad-1-l" style={{ fontWeight: 300 }}>
              {productName}
            </h1>
          </div>
          <div className="col-md-3 col-xl-3 flex flex-align-items-center">
            {showBannerLink && (
              <div className="text-align-right-md-up">
                <ButtonTertiary
                  type="button"
                  className="dls-deep-blue-bg-hvr text-underline dls-white pad-0-lr fluid"
                  style={{ whiteSpace: 'normal' }}
                  onClick={toggleBYBModal}
                  reactlytics={{ element: 'BYB', detail: 'BYB' }}
                >
                  <FormattedMessage id="banner.link" />
                </ButtonTertiary>
              </div>
            )}
          </div>
        </div>
      </div>
      {showBYBModal && (
        <BYBModal toggleBYBModal={toggleBYBModal} />
      )}
    </>
  );
};

Header.propTypes = {
  showBannerLink: PropTypes.bool,
};

export default Header;
